


























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Enums from '@/lib/enums'
import { classPrintWorld } from '@/common/js/PrintWorld'
class AttachmentPringting {
    printingNumber: number = 1;
}
@Component
export default class AttachmentPrintingModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    isLoadPrintList: boolean = false;
    PringtingModel: AttachmentPringting = new AttachmentPringting();
    isDisplay: boolean;
    created() {
        this.enterSearch();
    }
    enterSearch() {
        var _this = this;
        document.onkeydown = e => {
            //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
            //if (e.keyCode === 13 && _this.isDisplay) {
            //    //回车后执行搜索方法
            //   // _this.check();
            //}
            if (e.keyCode === 38 && _this.isDisplay) {
                this.check();
            }
            else if (e.keyCode === 40 && _this.isDisplay) {
                this.jumpto();
            }
        }
    }
    async check() {
        var url = this.$store.state.backstockproduct.pdfUrl;
        if (!this.isLoadPrintList) {
            var printWorld = new classPrintWorld(); //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。
            var json = {
                action: "", refresh: true, defaultprn: true, error: "", val: {}
            };
            json.action = "printers";
            json.refresh = true;                      //为true，则可确保返回刚刚添加的打印机。
            json.defaultprn = true;                   //是否包含缺省打印机信息。
            json = printWorld.Direct(json);
            if (json == null) {//数据发送失败
                alert(printWorld.GetLastError());
            } else if (json.error != undefined) {   //打天下打印服务返回的错误信息
                alert(json.error);
            } else {    //处理包含打印机列表的json
            }


            var Options = new Array();
            for (var i in json.val) {
                var option = document.createElement('option');
                option.innerHTML = json.val[i].name;
                option.value = json.val[i].name;
                document.getElementById('AttachmentSelectPrint').appendChild(option);
            }
            this.isLoadPrintList = true;
            this.$Message.success("已加载打印机，请选择指定打印机");
            return;
        }

        var pdfData = {
            url: url,
        };
        var printSelect: any = document.querySelector('#AttachmentSelectPrint');
        if (!printSelect.value) {
            this.$Message.success("请选择指定打印机");
            return;
        }
        
        if (pdfData.url && pdfData.url.length > 0) {
            var jsonsList = [];
            var printWorld = new classPrintWorld(); //new 一个打天下对象
            for (var j = 0; j < this.PringtingModel.printingNumber; j++) {

           
                var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
                jsons.action = "printfile";      
                jsons.format = "pdf_url";        //指定格式为pdf_url。
                jsons.content = pdfData.url;   //pdf文件的url路径
                jsons.paperlength = 15;
                jsons.paperwidth = 10;
                jsons.cert = "https://tkyc.ddtmx.com/cer/fileprintauth.ctf";
                jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                jsonsList.push(jsons);
            }
            printWorld.Direct(jsonsList);
        }
    }

    async jumpto() {
        (this.$refs.printingForm as any).resetFields();
        this.$emit('input', false);
        var timestamp1 = (new Date()).valueOf().toString();
        setTimeout(() => {
            this.$router.push({ name: 'intoLogistics', params: { StockJumpPage: timestamp1 } });
        },500);
        //this.$nextTick(() => {
           
        //});
      
    }

    cancel() {
        (this.$refs.printingForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        this.isDisplay = value;
        if (!value) {
            this.$emit('input', value);
        } else {
        }
    }
}
